import type { ApiMcpServer } from "~/server/api/organizations/[organizationId]/mcpServers/types";

export function useApiMcpServers() {
  const { organizationId } = useOrganizationId();
  return useFetch<ApiMcpServer[]>(
    () => `/api/organizations/${organizationId.value}/mcpServers`,
    {
      key: `apiMcpServers-${organizationId.value}`
    }
  );
}

export function refreshApiMcpServersData() {
  const { organizationId } = useOrganizationId();
  return refreshNuxtData(`apiMcpServers-${organizationId.value}`);
}
